import React, {useEffect, useState, useTransition} from 'react';
import {useTheme} from "../../../common/ProjectThemeProvider";
import {
    checkNullArr,
    checkNullStr,
    getArrLen,
    getJsonValue,
    getHighlightedMatchedText,
    isBoolTrue,
    isJsonValueTrue,
    limitStringWords,
    shuffleList,
    sortJsonListAdvance
} from "../../../common/fusion-ui/utils/ReactUtils";
import {formatDateValue, isCurrUserRoleAdmin, printError, printLog, sendRequest} from "../../utils/AppUtils";
import {useToast} from "../../../common/fusion-ui/provider/ToastProvider";
import {GenRouteUrls, Keys, ModuleFieldsData, Modules, ReqUrls} from "../../config/AppConfig";
import {InternalPageHeaderBar, RecordsPagination, ThemedConfirmDialog, ThemedIconButton} from "../../index";
import {Flexbox, GridBox, Label, LoadingSection, Popover, Section} from '../../../common/fusion-ui';
import {CssVariant, DefStrNA} from 'common/fusion-ui/config/FusionConfig';
import useScreenSize from "../../../common/fusion-ui/hook/useScreenSize";
import {useConfig} from "../../context/ConfigProvider";
import {AnimationType, FramerAnimator} from "../../../common/fusion-ui/animation/FramerAnimator";

const VideoPanel = React.memo(({
                                   recordList = [],
                                   loadingStatus = {},
                                   onRecordsUpdate,
                               }) => {
    const TAG = "VideoPanel";
    const moduleName = Modules.Videos;
    const mf = ModuleFieldsData[moduleName];

    const animator = new FramerAnimator();

    const theme = useTheme();
    const {showToast, changeToastVariant} = useToast();
    const {isScreenXs, isScreenSm, isScreenMd, isScreenResizing} = useScreenSize();
    const {updateConfig} = useConfig();

    const PAGINATION_RECORD_LIMITS = [2, 4, 6, 10, 14, 18];
    const DEF_PGNTN_RECORD_LIMIT = PAGINATION_RECORD_LIMITS[1];
    const DEF_PGNTN_START_INDEX = 1;
    const TITLE_CHAR_LIMIT = isScreenSm || isScreenXs ? 65 : 55;
    const DESC_CHAR_LIMIT = 150;

    const SEARCH_BY_PARAMS = {
        anything: {
            name: 'Anything'
        },
        title: {
            name: mf.title.title
        },
        desc: {
            name: mf.desc.title
        },
        date: {
            name: mf.insertDate.titleAlt
        }
    };
    const SORT_BY_PARAMS = {
        title: {
            name: mf.title.title,
            sortKey: mf.title.column,
        },
        desc: {
            name: mf.desc.title,
            sortKey: mf.desc.column,
        },
        date: {
            name: mf.insertDate.titleAlt,
            sortKey: mf.insertDate.column,
        },
    };

    const Fields = {
        recordList: 'recordList',

        isDataLoading: 'isDataLoading',
        dataLoadingMsg: 'dataLoadingMsg',
        isDataFound: 'isDataFound',

        searchInputValue: 'searchInputValue',
        searchBySelectedOption: 'searchBySelectedOption',

        sortBySelectedOption: 'sortBySelectedOption',
        isSortByOrderAsc: 'isSortByOrderAsc',

        pagination_currPageNum: 'pagination_currPageNum',
        pagination_currPageLimit: 'pagination_currPageLimit',

        recordDeleteBtn_Disable: 'recordDeleteBtn_Disable',
        recordDeleteBtn_AsLoading: 'recordDeleteBtn_AsLoading',
        currRecordDeleteId: 'currRecordDeleteId',
        showDeleteDialog: 'showDeleteDialog',
    };

    const [fieldsData, setFieldsData] = useState({});

    const [sortListPending, startSortListTransition] = useTransition();
    const [searchListPending, startSearchListTransition] = useTransition();

    useEffect(() => {
        // if (!checkNullStr(getField(Fields.pagination_currPageNuxm))) {
        updateField(Fields.pagination_currPageNum, DEF_PGNTN_START_INDEX);
        updateField(Fields.pagination_currPageLimit, DEF_PGNTN_RECORD_LIMIT);


        //Initial def-values
        if (!checkNullStr(getField(Fields.searchBySelectedOption))) {
            updateConfig(Keys.tracker_currPageModule, moduleName);
            updateConfig(Keys.tracker_currPageTag, TAG);
            updateField(Fields.searchBySelectedOption, SEARCH_BY_PARAMS.anything.name);
            updateField(Fields.sortBySelectedOption, SORT_BY_PARAMS.title.name);
            updateField(Fields.isSortByOrderAsc, true);
        }
        // }
    }, []);

    useEffect(() => {
        // log('useEffect.recordList:', recordList);
        updateField(Fields.isDataLoading, true);
        updateField(Fields.recordList, recordList);
        // updateField(Fields.recordList, VidPanel_Data);
        updateField(Fields.isDataLoading, !isJsonValueTrue(loadingStatus, 'loaded'));
        updateField(Fields.isDataFound, isJsonValueTrue(loadingStatus, 'success'));
        updateField(Fields.dataLoadingMsg, getJsonValue(loadingStatus, 'msg'));
    }, [recordList, loadingStatus]);

    return (<>
        {createPanel()}
        {createDeleteDialog()}
    </>);

    //======================UI Functions start=====================
    function createPanel() {
        return <div className="">
            <div className={'position-relative'}>
                {/*header-bar*/}
                <InternalPageHeaderBar
                    px={0}

                    moduleName={moduleName}

                    uploadUrl={GenRouteUrls.vid_uploadPage}
                    recomUrl={GenRouteUrls.vid_recomPage}

                    showSearch={true}
                    showSort={true}
                    showSearchBy={true}
                    searchByParams={SEARCH_BY_PARAMS}
                    sortByParams={SORT_BY_PARAMS}

                    recordsLen={getArrLen(getRecordList())}
                    filteredRecordsLen={getArrLen(getRecordList(true))}
                    searchValue={getField(Fields.searchInputValue)}
                    searchByDefOption={getField(Fields.searchBySelectedOption)}
                    sortByDefOption={getField(Fields.sortBySelectedOption)}
                    isSorting={sortListPending}
                    isSearching={searchListPending}
                    isSortAsc={isFieldTrue(Fields.isSortByOrderAsc)}

                    onUploadClick={(e) => {
                    }}
                    onRecomClick={(e) => {
                    }}
                    onSearchChange={(e, value) => handleSearchInputChange(value)}
                    onSearchBy={(name, item, index) => {
                        updateField(Fields.searchBySelectedOption, name);
                        handleSearchInputChange(getField(Fields.searchInputValue), name);
                    }}
                    onSort={(name, item, index, sortKey) => {
                        handleSortByChange(name, sortKey);
                    }}
                />
            </div>

            {/*body*/}
            {<div className={'position-relative'}>
                {/* record lists */}
                {(isFieldTrue(Fields.isDataFound) && isFieldTrue(Fields.isDataFound)) &&
                    <div className={""}>
                        <GridBox className={'px-1'} sm={12} md={6} gap={1}>
                            {getRecordListToRender().map((item, index) => {
                                const recordId = getJsonValue(item, mf.recordId.column);
                                return animator.setAnimationType(AnimationType.SLIDE_UP).setDelay(100 * index).render(
                                    <Section
                                        className={'p-0 h-100 app-section hover'}
                                        overflow={'hidden'}
                                        key={index + getJsonValue(item, mf.title.column)}
                                        borderColor={theme.text20}>
                                        <div className={''}>
                                            <div className={''}>
                                                <iframe
                                                    className="embed-responsive-item"
                                                    title={`Video ${index}`}
                                                    width="100%"
                                                    height="220px"
                                                    src={`https://www.youtube.com/embed/${item[mf.url.column]}`}
                                                    allowFullScreen
                                                ></iframe>
                                            </div>
                                            <div className={'px-3 mb-2'}>
                                                {/*title*/}
                                                <div>
                                                    <Label className={'m-0 p-0 fw-semi-bold text-break'} textAt={'start'} color={theme.text}
                                                           tooltip={(getJsonValue(item, mf.title.column) + '').length >= TITLE_CHAR_LIMIT ? getJsonValue(item, mf.title.column) : ''}>
                                                        <span
                                                            className={'fw-semi-boldx'}>
                                                            {highlightSearchMatchedText(limitStringWords(getJsonValue(item, mf.title.column, DefStrNA), TITLE_CHAR_LIMIT, '', '...'), SEARCH_BY_PARAMS.title.name)}
                                                        </span>
                                                    </Label>
                                                </div>

                                                {/*desc*/}
                                                <div>
                                                    <Label className={'m-0 p-0 mt-1'} color={theme.text80} textAt={'start'}>
                                                                <span>
                                                                    {highlightSearchMatchedText(limitStringWords(getJsonValue(item, mf.desc.column, DefStrNA), DESC_CHAR_LIMIT, '', ''), SEARCH_BY_PARAMS.desc.name)}
                                                                </span>

                                                        {((getJsonValue(item, mf.desc.column, DefStrNA) + '').length >= DESC_CHAR_LIMIT) && <Popover
                                                            title={getJsonValue(item, mf.desc.column, DefStrNA)}
                                                            minShowLimit={DESC_CHAR_LIMIT}>
                                                            <span>...</span>
                                                        </Popover>}
                                                    </Label>
                                                </div>

                                                {/*insertDate*/}
                                                <div>
                                                    <Label className={'m-0 p-0 text-break'} textAt={'start'} color={theme.text}>
                                                        <span className={'fw-semi-bold'}>{mf.insertDate.titleAlt}: </span>
                                                        <span className={'text-nowrap'}>
                                                            {highlightSearchMatchedText(formatDateValue(getJsonValue(item, mf.insertDate.column), DefStrNA), SEARCH_BY_PARAMS.date.name)}
                                                        </span>
                                                    </Label>
                                                </div>

                                                {/*controls*/}
                                                <div>
                                                    {isCurrUserRoleAdmin() && <Flexbox
                                                        justifyAt={'center'}
                                                        alignAt={'center'}>
                                                        {/*edit*/}
                                                        <ThemedIconButton
                                                            className={' text-nowrap fs-sm'}
                                                            tooltip={`Edit Video`}
                                                            icon={'bi bi-pencil'}
                                                            variant={theme.primaryBlue}
                                                            size={'26px'}
                                                            outlined={true}
                                                            circular={true}
                                                            mx={2}
                                                            href={`${GenRouteUrls.vid_editPage}${recordId}`}
                                                        />

                                                        {/*delete*/}
                                                        <ThemedIconButton
                                                            className={''}
                                                            tooltip={'Delete'}
                                                            m={1}
                                                            ml={2}
                                                            variant={'red'}
                                                            bgColor={theme.textWhite}
                                                            hoverBgColor={'red'}
                                                            outlined={true}
                                                            icon={'bi bi bi-trash'}
                                                            iconSize={'11px'}
                                                            size={'26px'}
                                                            loadingVariant={CssVariant.danger}
                                                            asLoading={isFieldTrue(Fields.recordDeleteBtn_AsLoading) && getField(Fields.currRecordDeleteId) == recordId}
                                                            disabled={isFieldTrue(Fields.recordDeleteBtn_Disable) && getField(Fields.currRecordDeleteId) == recordId}
                                                            onClick={() => {
                                                                updateField(Fields.currRecordDeleteId, recordId);
                                                                updateField(Fields.showDeleteDialog, true);
                                                            }}
                                                        />
                                                    </Flexbox>}
                                                </div>
                                            </div>
                                        </div>
                                    </Section>,
                                    {className: 'h-100'}
                                )
                            })}
                        </GridBox>
                    </div>}

                {/*No search-found*/}
                {((isSearchOngoing() && !searchListPending && checkNullArr(getRecordList()) && !checkNullArr(getRecordList(true)))) &&
                    <Flexbox className={'h-80 select-none'} justifyAt={'center'} alignAt={'center'} direction={'column'} wrap={'wrap'}>
                        <Label className={'m-1 w-100 fs-xxl fw-semi-bold'} color={theme.primary50}>
                            Search not found!
                        </Label>
                    </Flexbox>}

                {<LoadingSection
                    labelClassName={'m-1 w-100 fs-xxl fw-semi-bold'}
                    heightClass={75}
                    color={theme.primary50}
                    success={isFieldTrue(Fields.isDataFound)}
                    loading={isFieldTrue(Fields.isDataLoading)}
                    msg={getField(Fields.dataLoadingMsg)}
                />}
            </div>}

            {/* pagination */}
            <RecordsPagination
                id={TAG}
                position={'sticky'}
                bottom={'-.1rem'}
                zIndex={1}
                bgColor={theme.primary10Opaque}
                currPageRecordLimit={getField(Fields.pagination_currPageLimit)}
                currPage={getField(Fields.pagination_currPageNum)}
                scrollToTopOnPageChange={false}
                totalRecords={getArrLen(getRecordList(true))}
                totalRecordsToRender={getArrLen(getRecordListToRender())}
                recordLimits={PAGINATION_RECORD_LIMITS}
                onPageChange={(e, newPageIndex) => {
                    // log('RecordsPagination.onLimitChange.newPageIndex:', newPageIndex);
                    updateField(Fields.pagination_currPageNum, newPageIndex);
                }}
                onLimitChange={(newLimit, newPageIndex) => {
                    // log('RecordsPagination.onLimitChange.newLimit:', newLimit, 'newPageIndex:', newPageIndex);
                    updateField(Fields.pagination_currPageLimit, newLimit);
                    updateField(Fields.pagination_currPageNum, newPageIndex);
                }}
            />
        </div>
    }

    function createDeleteDialog() {
        return <ThemedConfirmDialog
            open={isFieldTrue(Fields.showDeleteDialog)}
            onCancel={() => updateField(Fields.showDeleteDialog, false)}
            onHide={() => updateField(Fields.currRecordDeleteId, null)}
            title={`Delete video`}
            subMsg={getJsonValue(getRecordList().find(item => getField(Fields.currRecordDeleteId) == getJsonValue(item, mf.recordId.column)), mf.title.column)}
            operation={'delete'}
            target={'this video'}
            onConfirm={() => {
                handleRecordDelete();
            }}
        />
    }

    //======================UI Functions end=====================
    function handleRecordDelete() {
        const fun = 'handleRecordDelete';
        const recordId = getField(Fields.currRecordDeleteId);
        if (checkNullStr(recordId)) {
            updateField(Fields.recordDeleteBtn_Disable, true);
            updateField(Fields.recordDeleteBtn_AsLoading, true);
            try {
                const REQUEST_OPTIONS = {recordId: recordId};
                sendRequest({
                    reqUrl: ReqUrls.vid__mainPage_delete_record,
                    reqOptions: REQUEST_OPTIONS,
                    onFetched: ((fetchedData) => {
                        log(fun, 'fetchedData:', fetchedData);
                        updateField(Fields.showDeleteDialog, false)

                        const success = isJsonValueTrue(fetchedData, 'success');
                        const message = getJsonValue(fetchedData, 'message');
                        if (success) {
                            toast(message, CssVariant.success);
                            log(fun, 'getRecordList-old.before:', getArrLen(getRecordList()));

                            //Remove this recordId item from recordList
                            const recordList = getRecordList().filter((item) => recordId != getJsonValue(item, mf.recordId.column));
                            updateField(Fields.recordList, recordList);
                            if (onRecordsUpdate) onRecordsUpdate(recordList);
                            log(fun, 'getRecordList-after.length:', getArrLen(recordList));

                            if (!checkNullArr(recordList)) {
                                updateField(Fields.isDataFound, false);
                                updateField(Fields.dataLoadingMsg, "No records found!");
                            }
                        } else {
                            toast(message, CssVariant.danger);
                        }
                        updateField(Fields.currRecordDeleteId, null);
                        updateField(Fields.recordDeleteBtn_Disable, false);
                        updateField(Fields.recordDeleteBtn_AsLoading, false);
                    }),
                    onError: ((error) => {
                        logErr(fun, error);
                        updateField(Fields.recordDeleteBtn_Disable, false);
                        updateField(Fields.recordDeleteBtn_AsLoading, false);
                    }),
                });
            } catch (error) {
                logErr(fun, error);
                updateField(Fields.recordDeleteBtn_Disable, false);
                updateField(Fields.recordDeleteBtn_AsLoading, false);
            }
        } else {
            toast('Record-id not found!', CssVariant.danger);
        }
    }


    //======================Util Functions start=====================
    function handleSearchInputChange(inputValue, searchByOption = getField(Fields.searchBySelectedOption)) {
        const fun = 'handleSearchInputChange:';
        try {
            // if (inputValue == InputFocusShortcutKey) {
            //     return;
            // }
            updateField(Fields.searchInputValue, inputValue);
            // startSearchListTransition(() => {
            // Filter search query based on selected search filter
            const inputValueL = (inputValue + '').toLowerCase();
            let recordList = getRecordList();
            if (checkNullStr(inputValue) && checkNullArr(recordList)) {
                recordList = recordList.map((item) => {
                    const title = (getJsonValue(item, mf.title.column) + '').toLowerCase();
                    const desc = (getJsonValue(item, mf.desc.column) + '').toLowerCase();
                    const date = (formatDateValue(getJsonValue(item, mf.insertDate.column), getJsonValue(item, mf.insertDate.column)) + '').toLowerCase();

                    let matched = false;
                    switch (searchByOption) {
                        case SEARCH_BY_PARAMS.anything.name:
                            matched = (title + desc + date).includes(inputValueL);
                            break;
                        case SEARCH_BY_PARAMS.title.name:
                            matched = title.includes(inputValueL);
                            break;
                        case SEARCH_BY_PARAMS.desc.name:
                            matched = desc.includes(inputValueL);
                            break;
                        case SEARCH_BY_PARAMS.date.name:
                            matched = date.includes(inputValueL);
                            break;
                    }
                    return {
                        ...item,
                        searched: matched
                    }
                });
                // log(fun, 'inputValue:', inputValue, 'searchBy:', getField(Fields.searchBySelectedOption), 'recordList', recordList);
            }

            // update-list
            startSearchListTransition(() => {
                updateField(Fields.recordList, recordList);
            });
        } catch (error) {
            logErr(fun, error);
            toast('Search failed, please try again', CssVariant.danger);
        }
    }

    function handleSortByChange(name, sortKey) {
        const fun = 'handleSortByChange:';
        try {
            startSortListTransition(() => {
                const sortOption = getField(Fields.sortBySelectedOption);
                const order = name == sortOption ? !isFieldTrue(Fields.isSortByOrderAsc) : isFieldTrue(Fields.isSortByOrderAsc);

                updateField(Fields.isSortByOrderAsc, order);
                updateField(Fields.sortBySelectedOption, name);

                updateField(Fields.recordList, sortJsonListAdvance(shuffleList(getRecordList()), sortKey, order));
            });
        } catch (error) {
            toast('Sort failed, please try again', CssVariant.danger);
            logErr(fun, error);
        }
    }

    function highlightSearchMatchedText(text, searchByParam) {
        const can = (getField(Fields.searchBySelectedOption) == SEARCH_BY_PARAMS.anything.name || getField(Fields.searchBySelectedOption) == searchByParam);
        return can ? getHighlightedMatchedText(text, getField(Fields.searchInputValue)) : text;
    }

    function getRecordList(searchedOnly = false) {
        if (checkNullArr(getField(Fields.recordList))) {
            if (isBoolTrue(searchedOnly) && isSearchOngoing()) {
                return getField(Fields.recordList).filter(item => isJsonValueTrue(item, 'searched'))
            }
            return getField(Fields.recordList);
        }
        return [];
    }

    function getRecordListToRender() {
        return getRecordList(true).slice((getField(Fields.pagination_currPageNum) - 1) * getField(Fields.pagination_currPageLimit), getField(Fields.pagination_currPageNum) * getField(Fields.pagination_currPageLimit));
    }

    function isSearchOngoing() {
        return checkNullStr(getField(Fields.searchInputValue));
    }

    function updateField(field, value) {
        setFieldsData(prevState => ({...prevState, [field]: value}));
    }

    function getField(field, defValue) {
        return getJsonValue(fieldsData, field, defValue);
    }

    function isFieldTrue(field) {
        return isBoolTrue(getField(field), true, true);
    }

    function toast(text, variant) {
        showToast(text);
        changeToastVariant(variant);
        log(...[text]);
    }

    function log(...text) {
        printLog(TAG, ...text);
    }

    function logErr(...text) {
        printError(TAG, ...text);
    }

    //======================Util Functions end=====================
});
export default VideoPanel;
